import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
  RedirectRequest,
} from '@azure/msal-browser';

interface IPolicies {
  names: {
    signUpSignIn: string;
    newUser: string;
    editProfile: string;
    adminEditProfile: string;
  };
  authorities: {
    signUpSignIn: RedirectRequest;
    newUser: RedirectRequest;
    editProfile: RedirectRequest;
    adminEditProfile: RedirectRequest;
  };
  authorityDomain: string;
}

export const b2cPolicies: IPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_PA_SIGNIN',
    newUser: 'B2C_1A_PA_NEWUSER',
    editProfile: 'B2C_1A_PA_PROFILEEDIT',
    adminEditProfile: 'B2C_1A_PA_PROFILEEDIT_ADMIN',
  },
  authorities: {
    signUpSignIn: {
      scopes: [],
      authority: process.env.REACT_APP_B2C_AUTH_SIGN_IN,
    },
    newUser: {
      scopes: [],
      authority: process.env.REACT_APP_B2C_NEW_USER,
    },
    editProfile: {
      scopes: [],
      authority: process.env.REACT_APP_B2C_PROFILE_EDIT,
    },
    adminEditProfile: {
      scopes: [],
      authority: process.env.B2C_1A_PA_PROFILEEDIT_ADMIN,
    },
  },
  authorityDomain: process.env.REACT_APP_B2C_DOMAIN || 'No Domain',
};

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_B2C_CLIENT_ID || 'no clientId', // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: process.env.REACT_APP_B2C_REDIRECT_URI || 'no redirect uri', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            return;
          case LogLevel.Warning:
            return;
        }
      },
    },
  },
};

export const protectedResources = {
  apiHello: {
    endpoint: '',
    scopes: [''], // e.g. api://xxxxxx/access_as_user  | NOT USED Therefor no Scope
  },
};

export const loginRequest = {
  scopes: process.env.REACT_APP_B2C_SCOPE
    ? [process.env.REACT_APP_B2C_SCOPE]
    : [],
};
